import headerLogo from "@assets/headerLogo.svg";
import EPublicRoutes from "@core-types/routes.enum";
import { Image } from "@mantine/core";
import { Link } from "react-router";

interface ILogoProps {
  h?: number;
  w?: number;
}

const Logo: React.FC<ILogoProps> = ({ w = 145, h = 37 }) => {
  return (
    <Link to={EPublicRoutes.HOME}>
      <Image
        alt="secret smurfs logo"
        fallbackSrc=""
        h={h}
        loading="lazy"
        src={headerLogo}
        title="Logo de secret smurf"
        w={"auto"}
        width={w}
      />
    </Link>
  );
};

export default Logo;
